"use client"
import { useAuthActions } from "@convex-dev/auth/react";
import { Button } from "../ui/button";
import { useState } from "react";

export function SignInButton() {
  const { signIn } = useAuthActions();
  const [isSigningIn, setIsSigningIn] = useState(false);

  const handleSignIn = async () => {
    setIsSigningIn(true);
    // Capture the current page URL to redirect back after sign-in
    const redirectTo = window.location.href;
    try {
      await signIn("google", {redirectTo});
    } catch (error) {
      console.error("Failed to sign in:", error);
      setIsSigningIn(false);
    }
  };

  return (
    <Button onClick={handleSignIn} disabled={isSigningIn} data-attr="auth-sign-in">
      {isSigningIn ? "Signing in..." : "Sign in with Google"}
    </Button>
  );
}